import {
  KI_KUARTAL,
  KI_PERUSAHAAN,
  KI_YEAR,
  KI_DATA,
  KI_TYPE,
} from "../../../constants";

const currentYear = new Date().getFullYear();

const initial = {
  year: currentYear - 1,
  kuartal: 1,
  type: 1, // laba kotor, ebitda, ebit, laba bersih
  data: [],
};

export default (state = initial, action) => {
  switch (action.type) {
    case KI_KUARTAL:
      return {
        ...state,
        kuartal: action.data,
      };
    case KI_YEAR:
      return {
        ...state,
        year: action.data,
      };
    case KI_TYPE:
      return {
        ...state,
        type: action.data,
      };
    case KI_PERUSAHAAN:
      return {
        ...state,
        perusahaan: action.data,
      };
    case KI_DATA:
      return { ...state, data: action.data };
    default:
      return { ...state };
  }
};


// const currentYear = new Date().getFullYear();
// const INITIAL_STATE = {
//   currentYear: currentYear,
//   url: "laba-kotor-kinerja",
//   type: 2,
//   bumd: "00ed7c5c-b0db-4ec3-8639-551603409a79",
//   jenis: "",
//   periode: "",
//   kinerja: "",
//   startMonth: 0,
//   endMonth: 0,
//   startYear: 2020,
//   endYear: 2022
// };

// export default (state = INITIAL_STATE, action) => {
//   switch (action.type) {
//     case "change_var_filter":
//       return { ...state, [action.payload.prop]: action.payload.value };
//     default:
//       return state;
//   }
// };
